import { Type } from '@sinclair/typebox';
import { MakerTagSchema } from '../maker.js';
import { OwnerProfileSchema } from '../owner-profile.js';
import { SupportedDexSchema } from '../supported-dex.js';
import { SupportedNetworkSchema } from '../supported-network.js';
import { TxOperationSchema, TxTokenSchema } from './base-tx.js';
export const ShortTxSchema = Type.Object({
    id: Type.String(),
    pairAddress: Type.String(),
    network: SupportedNetworkSchema,
    txSignature: Type.String(),
    operation: TxOperationSchema,
    marketCap: Type.String(),
    liquidityInUsd: Type.String(),
    quoteAmount: Type.String(),
    baseAmount: Type.String(),
    baseAddress: Type.String(),
    quoteAddress: Type.String(),
    provider: SupportedDexSchema,
    tokenPriceInUsd: Type.String(),
    tokenPriceInNative: Type.String(),
    volumeInUsd: Type.String(),
    volumeInNative: Type.String(),
    timestamp: Type.String(),
    maker: Type.Object({
        address: Type.String(),
        buyVolumeInUsd: Type.String(),
        buyVolumeInToken: Type.String(),
        sellVolumeInUsd: Type.String(),
        sellVolumeInToken: Type.String(),
        remainingInToken: Type.String(),
        /** Total PnL = rPnl + uPnl, cost-basis accounting (see @blade/finance-core). */
        pnl: Type.String(),
        /** Realized PnL = sellVolumeInUsd - sellVolumeInToken * entryPrice, where entryPrice = buyVolumeInUsd / buyVolumeInToken. */
        rPnl: Type.String(),
        /** Unrealized PnL = remaining holdings * (currentPrice - entryPrice). */
        uPnl: Type.String(),
        volumeInUsd: Type.String(),
        txCount: Type.String(),
        buys: Type.String(),
        sells: Type.String(),
        /** Volume-weighted avg buy price (USD per token) = buyVolumeInUsd / buyVolumeInToken. */
        avgBuyPrice: Type.Optional(Type.String()),
        /** Volume-weighted avg sell price (USD per token) = sellVolumeInUsd / sellVolumeInToken. */
        avgSellPrice: Type.Optional(Type.String()),
        /** avgBuyPrice scaled to market cap via the tx's supply factor (marketCap / tokenPriceInUsd). */
        avgBuyMarketCap: Type.Optional(Type.String()),
        /** avgSellPrice scaled to market cap via the tx's supply factor (marketCap / tokenPriceInUsd). */
        avgSellMarketCap: Type.Optional(Type.String()),
        firstTxAt: Type.String(),
        tags: Type.Optional(Type.Array(MakerTagSchema)),
        owner: Type.Optional(OwnerProfileSchema),
    }),
    balanceBefore: Type.String(),
    balanceAfter: Type.String(),
});
export const ShortTxWithMetadataSchema = Type.Intersect([
    ShortTxSchema,
    Type.Object({
        tokenMetadata: TxTokenSchema,
    }),
]);
export const ShortTxMaybeWithMetadataSchema = Type.Intersect([
    ShortTxSchema,
    Type.Object({
        tokenMetadata: Type.Optional(TxTokenSchema),
    }),
]);
//# sourceMappingURL=short-tx.js.map